var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.266667,
    y: 0.266667,
    width: 31.4667,
    height: 31.4667,
    rx: 7.73333,
    stroke: "#6B6084",
    strokeWidth: 0.533333
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_201_1599)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6957 8.09818C11.3934 8.15694 10.2647 8.47534 9.35319 9.38295C8.43856 10.2953 8.12411 11.4286 8.06521 12.7173C8.02859 13.5217 7.81447 19.5986 8.43537 21.1923C8.85408 22.2675 9.67875 23.0941 10.7637 23.5142C11.27 23.7111 11.848 23.8444 12.6957 23.8833C19.7844 24.2041 22.4121 24.0295 23.5201 21.1923C23.7168 20.6873 23.8521 20.1099 23.8895 19.2642C24.2135 12.1574 23.837 10.6169 22.6015 9.38295C21.6216 8.40546 20.469 7.74006 12.6957 8.09818ZM12.761 22.454C11.9849 22.4191 11.5638 22.2898 11.2828 22.181C10.5759 21.9063 10.0449 21.3775 9.7719 20.6747C9.29905 19.4638 9.45588 13.7124 9.49807 12.7818C9.53946 11.8702 9.72414 11.0371 10.3673 10.3939C11.1634 9.59982 12.1918 9.21066 19.1945 9.5267C20.1083 9.56799 20.9434 9.75229 21.5882 10.3939C22.3842 11.1879 22.779 12.2243 22.4574 19.2001C22.4224 19.9743 22.2927 20.3944 22.1836 20.6747C21.4632 22.5209 19.8059 22.7772 12.761 22.454ZM19.2717 11.7517C19.2717 12.2774 19.6992 12.7048 20.227 12.7048C20.7547 12.7048 21.183 12.2774 21.183 11.7517C21.183 11.226 20.7547 10.799 20.227 10.799C19.6992 10.799 19.2717 11.226 19.2717 11.7517ZM11.8901 15.9904C11.8901 18.2423 13.7202 20.0681 15.9778 20.0681C18.2353 20.0681 20.0654 18.2423 20.0654 15.9904C20.0654 13.7384 18.2353 11.9138 15.9778 11.9138C13.7202 11.9138 11.8901 13.7384 11.8901 15.9904ZM13.3246 15.9904C13.3246 14.5293 14.5123 13.3439 15.9778 13.3439C17.4432 13.3439 18.6309 14.5293 18.6309 15.9904C18.6309 17.4522 17.4432 18.638 15.9778 18.638C14.5123 18.638 13.3246 17.4522 13.3246 15.9904Z",
    fill: "#6B6084"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_201_1599"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaIcon);
export default __webpack_public_path__ + "static/media/InstaIcon.471f8360ecdd6c1de20c00bfd1deecab.svg";
export { ForwardRef as ReactComponent };